<script>
import { EXAMINATION } from "@/utils/data";
import testPaperDialog from "./components/testPaperDialog.vue";
import testUserDialog from "./components/testUserDialog.vue";
import testViewDialog from "./components/testViewDialog.vue";
import testScoreDialog from "./components/testScoreDialog.vue";
import categoryTree from "@/components/CategoryTree/index.vue";
import testDialog from "./components/testDialog.vue";
// import paperDialog from "@/pages/examination/components/paperDialog.vue";
export default {
  components: {
    // paperDialog,
    categoryTree,
    testPaperDialog,
    testUserDialog,
    testViewDialog,
    testScoreDialog,
    testDialog,
  },
  data() {
    return {
      typeList: EXAMINATION.TEST_STATUS_LIST,
      statusEnum: EXAMINATION.PAPER_STATUS,
      searchForm: {
        name: "",
        status: "",
      },
      pageInfo: {
        size: 20,
        page: 1,
        total: 0,
      },
      loading: false,
      categoryActive: 0,
      categoryData: [],
      tableData: [],
      testPaperDialog: {
        visible: false,
        id: "",
        title: "",
      },
      testUserDialog: {
        visible: false,
        id: "",
        title: "",
      },
      testViewDialog: {
        visible: false,
        id: "",
        title: "",
      },
      testScoreDialog: {
        visible: false,
        id: "",
        title: "",
      },
      testDialog: {
        visible: false,
        title: "",
        data: {},
        type: "create",
      },
    };
  },
  mounted() {
    this.handleLoad();
    this.handleLoadCategory();
  },
  methods: {
    handleLoadCategory() {
      this.$cloud.get("/category/index").then((data) => {
        this.categoryData = data;
        this.$nextTick(() => {
          this.$refs["scrollCategory"].update();
        });
      });
    },
    handleSizeChange(val) {
      this.pageInfo.size = val;
      this.handleLoad();
    },
    handleLoad() {
      this.loading = true;
      this.$cloud
        .get("/examination/test/list", { ...this.pageInfo, ...this.searchForm })
        .then((data) => {
          console.log("成员", data);
          this.tableData = data.children;
          this.pageInfo["total"] = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleSearch() {
      console.log("提交表单", this.searchForm);
      this.pageInfo.page = 1;
      this.handleLoad();
    },
    handleReset() {
      console.log("重置表单");
      this.searchForm.name = "";
      this.searchForm.type = "";
      this.handleSearch();
    },
    handleStatus(id, status) {
      console.log("修改状态", id, status);
      this.$cloud.post("examination/test/status", { id, status }).then(() => {
        this.$message.success("操作成功");
        this.handleLoad();
      });
    },
    handleRemove(id) {
      console.log("删除", id);
      this.$cloud.post("examination/test/remove", { id: id }).then(() => {
        this.$message.success("删除成功");
        this.handleLoad();
      });
    },
    handleCreate() {
      console.log("添加");
      this.testDialog.data = {};
      this.testDialog.type = "create";
      this.testDialog.title = "添加测试";
      this.testDialog.visible = true;
      // this.$prompt('请输入名称', '添加测验', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   beforeClose:(action, instance, done) => {
      //     console.log('action, done',action, done)
      //     console.log('instance',instance)
      //     if(action === 'confirm'){
      //       instance.confirmButtonLoading = true
      //       this.$cloud.post('examination/test/add',{name:instance.inputValue}).then(() => {
      //         instance.confirmButtonLoading = false
      //         this.$message({
      //           type: 'success',
      //           message: '添加成功'
      //         });
      //         done()
      //       })
      //     }else{
      //       done()
      //     }
      //   }
      // }).then(() => {
      //   this.handleLoad()
      // })
    },
    handleView(data) {
      console.log("查看", data);
      this.testViewDialog.id = data.id;
      this.testViewDialog.title = data.name;
      this.testViewDialog.visible = true;
    },
    handleMarking(data) {
      console.log("批改试卷", data);
      this.$cloud.go("/pages/examination/marking?testId=" + data.id);
    },
    handleScoreView(data) {
      console.log("成绩查看", data);
      this.testScoreDialog.id = data.id;
      this.testScoreDialog.title = data.name;
      this.testScoreDialog.visible = true;
    },
    handleEdit(data) {
      console.log("编辑", data);
      this.testDialog.data = data;
      this.testDialog.type = "edit";
      this.testDialog.title = "修改测试";
      this.testDialog.visible = true;
      // this.$prompt('请输入名称', '编辑测验', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   inputValue: data.name,
      //   beforeClose:(action, instance, done) => {
      //     console.log('action, done',action, done)
      //     console.log('instance',instance)
      //     if(action === 'confirm'){
      //       instance.confirmButtonLoading = true
      //       this.$cloud.post('examination/test/edit',{id:data.id,name:instance.inputValue}).then(() => {
      //         instance.confirmButtonLoading = false
      //         this.$message({
      //           type: 'success',
      //           message: '修改成功'
      //         });
      //         done()
      //       })
      //     }else{
      //       done()
      //     }
      //   }
      // }).then(() => {
      //   this.handleLoad()
      // })
    },
    handleSetPaper(data) {
      console.log("设置试卷", data);
      this.testPaperDialog.id = data.id;
      this.testPaperDialog.title = data.name;
      this.testPaperDialog.visible = true;
    },
    handleSetTime(data) {
      console.log("设置时长", data);
      this.$prompt("请输入时长", "设置测验时长", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: data.time || 40,
        beforeClose: (action, instance, done) => {
          console.log("action, done", action, done);
          console.log("instance", instance);
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            this.$cloud
              .post("examination/test/set/time", {
                testId: data.id,
                time: instance.inputValue,
              })
              .then(() => {
                this.$message({
                  type: "success",
                  message: "设置成功",
                });
                done();
              })
              .finally(() => {
                instance.confirmButtonLoading = false;
              });
          } else {
            done();
          }
        },
      }).then(() => {
        this.handleLoad();
      });
    },
    handleSetUser(data) {
      console.log("设置用户", data);
      this.testUserDialog.id = data.id;
      this.testUserDialog.title = data.name;
      this.testUserDialog.visible = true;
    },
  },
};
</script>
<template>
  <div>
    <div class="w-full">
      <div class="flex">
        <div class="flex-grow pr-6">
          <div class="flex h-full">
            <div class="flex-1 ml-4">
              <div class="flex justify-between pt-6">
                <div>
                  <el-button type="primary" @click="handleCreate"
                    >添加</el-button
                  >
                </div>
                <div>
                  <el-form
                    ref="searchForm"
                    :inline="true"
                    :model="searchForm"
                    class="demo-form-inline"
                  >
                    <el-form-item label="名称">
                      <el-input
                        v-model="searchForm.name"
                        placeholder="请输入要搜索的名称"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                      <el-select
                        v-model="searchForm.status"
                        clearable
                        placeholder="请选择状态"
                      >
                        <el-option
                          v-for="type in typeList"
                          :key="type.value"
                          :label="type.name"
                          :value="type.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button @click="handleReset">重置</el-button>
                      <el-button @click="handleSearch" type="primary"
                        >查询</el-button
                      >
                    </el-form-item>
                  </el-form>
                </div>
              </div>

              <div>
                <el-table
                  :data="tableData"
                  v-loading="loading"
                  stripe
                  :height="$CSS.CARD_TABLE_HEIGHT"
                  style="width: 100%"
                >
                  <el-table-column type="index" label="编号" width="60">
                  </el-table-column>
                  <el-table-column prop="name" label="名称"> </el-table-column>
                  <el-table-column prop="time" label="时长(分钟)" width="80">
                  </el-table-column>
                  <el-table-column prop="statusName" label="状态" width="80">
                  </el-table-column>
                  <el-table-column
                    prop="startDate"
                    label="开始时间"
                    width="180"
                  >
                  </el-table-column>
                  <el-table-column prop="endDate" label="结束时间" width="180">
                  </el-table-column>
                  <el-table-column width="380" prop="address" label="操作">
                    <template slot-scope="scope">
                      <el-button
                        @click="handleView(scope.row)"
                        type="text"
                        size="small"
                        >查看</el-button
                      >
                      <el-divider direction="vertical"></el-divider>
                      <span v-if="scope.row.status === statusEnum.ON">
                        <el-button
                          @click="handleMarking(scope.row)"
                          type="text"
                          size="small"
                          >批改试卷</el-button
                        >
                        <el-divider direction="vertical"></el-divider>
                        <el-button
                          @click="handleScoreView(scope.row)"
                          type="text"
                          size="small"
                          >成绩查看</el-button
                        >
                        <el-divider direction="vertical"></el-divider>
                      </span>

                      <el-popconfirm
                        v-if="scope.row.status === statusEnum.OFF"
                        :title="'确定启用【' + scope.row.name + '】吗？'"
                        @confirm="handleStatus(scope.row.id, statusEnum.ON)"
                      >
                        <el-button slot="reference" type="text" size="small"
                          >启用</el-button
                        >
                      </el-popconfirm>
                      <el-popconfirm
                        v-if="scope.row.status === statusEnum.ON"
                        :title="'确定禁用【' + scope.row.name + '】吗？'"
                        @confirm="handleStatus(scope.row.id, statusEnum.OFF)"
                      >
                        <el-button slot="reference" type="text" size="small"
                          >禁用</el-button
                        >
                      </el-popconfirm>

                      <span v-if="scope.row.status === statusEnum.OFF">
                        <el-divider direction="vertical"></el-divider>
                        <el-button
                          @click="handleEdit(scope.row)"
                          type="text"
                          size="small"
                          >修改</el-button
                        >
                        <el-divider direction="vertical"></el-divider>
                        <el-button
                          @click="handleSetTime(scope.row)"
                          type="text"
                          size="small"
                          >设置时长</el-button
                        >
                        <el-divider direction="vertical"></el-divider>
                        <el-button
                          @click="handleSetPaper(scope.row)"
                          type="text"
                          size="small"
                          >设置试卷</el-button
                        >
                        <el-divider direction="vertical"></el-divider>
                        <el-button
                          @click="handleSetUser(scope.row)"
                          type="text"
                          size="small"
                          >设置人员</el-button
                        >
                        <el-divider direction="vertical"></el-divider>
                        <el-popconfirm
                          :title="'确定删除【' + scope.row.name + '】吗？'"
                          @confirm="handleRemove(scope.row.id)"
                        >
                          <el-button slot="reference" type="text" size="small"
                            >删除</el-button
                          >
                        </el-popconfirm>
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="py-6">
                  <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleLoad"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page.sync="pageInfo.page"
                    :page-sizes="[20, 50, 100, 200]"
                    :page-size="pageInfo.size"
                    :total="pageInfo.total"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <test-dialog
        :visible.sync="testDialog.visible"
        :title="testDialog.title"
        :data="testDialog.data"
        :type="testDialog.type"
        @refresh="handleLoad"
      ></test-dialog>
      <test-paper-dialog
        :visible.sync="testPaperDialog.visible"
        :title="testPaperDialog.title"
        :id="testPaperDialog.id"
      />
      <test-user-dialog
        :visible.sync="testUserDialog.visible"
        :title="testUserDialog.title"
        :id="testUserDialog.id"
      />
      <test-view-dialog
        :visible.sync="testViewDialog.visible"
        :title="testViewDialog.title"
        :id="testViewDialog.id"
      />
      <test-score-dialog
        :visible.sync="testScoreDialog.visible"
        :title="testScoreDialog.title"
        :id="testScoreDialog.id"
      />
    </div>
  </div>
</template>
<style scoped></style>
